const GraphXAxisLabelOption = {
  SHORT: 'förkortad',
  FULL: 'fullständig',
  INDEX: 'index',
  NONE: 'ingen',
};

export default GraphXAxisLabelOption;
